(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-responsivo-elegante"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('gie-elegant-slider')) return;
  let library;
  const loadLibrary = () => library ||= import('https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs').catch(error => {
    library = null;
    throw error;
  });
  class ElegantSlider extends HTMLElement {
    connectedCallback() {
      this.version = (this.version || 0) + 1;
      const version = this.version;
      // Wait until the parser has supplied this element's children.
      this.frame = requestAnimationFrame(async () => {
        try {
          const { default: Swiper } = await loadLibrary();
          if (!this.isConnected || version !== this.version) return;
          const container = this.querySelector('.responsive-slider');
          if (!container || container.swiper) return;
          const slides = [...container.querySelectorAll('.swiper-slide')];
          const editing = Boolean(window.Shopify?.designMode);
          this.swiper = new Swiper(container, {
            loop: !editing && slides.length > 1 && this.dataset.loop === 'true',
            autoplay: !editing && slides.length > 1 && this.dataset.autoplay === 'true'
              ? { delay: Number(this.dataset.delay) || 5000, disableOnInteraction: false } : false,
            speed: Number(this.dataset.speed) || 600,
            effect: this.dataset.effect || 'slide',
            fadeEffect: { crossFade: true },
            watchOverflow: true,
            touchStartPreventDefault: false,
            a11y: { scrollOnFocus: false },
            navigation: { nextEl: this.querySelector('.swiper-button-next'), prevEl: this.querySelector('.swiper-button-prev') },
            pagination: { el: this.querySelector('.swiper-pagination'), clickable: true }
          });
          this.selectBlock = event => {
            const index = slides.findIndex(slide => slide.dataset.blockId === event.detail?.blockId);
            if (index >= 0) this.swiper.slideTo(index, 0);
          };
          this.addEventListener('shopify:block:select', this.selectBlock);
        } catch (error) { console.warn('No se pudo iniciar el slider elegante:', error); }
      });
    }
    disconnectedCallback() {
      this.version = (this.version || 0) + 1;
      cancelAnimationFrame(this.frame);
      if (this.selectBlock) this.removeEventListener('shopify:block:select', this.selectBlock);
      this.swiper?.destroy(true, true);
      this.swiper = null;
    }
  }
  customElements.define('gie-elegant-slider', ElegantSlider);
})();

  } catch(e) { console.error(e); }
})();
})();
